<template>
  <div class="task-flow-container">
    <CardBox title="任务流转" subtitle="Real-time task flow">
      <div class="task-flow-list-wrapper">
        <vue-seamless-scroll
          :data="taskFlowList"
          :class-option="{
            limitMoveNum: 3,
            step: 0.4,
            hoverStop: true,
            direction: 1,
            openTouch: false
          }"
          style="height: 100%"
        >
          <div class="task-flow-list">
            <div v-for="(item, index) in taskFlowList" :key="index" class="task-flow-item">
              <img
                class="task-flow-item__bg"
                src="@/assets/image/homeIndex/task_flow_item_bg.png"
                alt=""
              />
              <div class="task-flow-item__content">
                <img
                  class="task-flow-item__icon"
                  src="@/assets/image/homeIndex/icon_task_flow.png"
                  alt=""
                />
                <div class="task-flow-item__info">
                  <span class="task-flow-item__text">{{ item.content }}</span>
                  <span class="task-flow-item__time">{{ item.createTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </CardBox>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import CardBox from './cardBox.vue'
import vueSeamlessScroll from 'vue-seamless-scroll/src'

export default {
  name: 'TaskFlowComponent',
  components: { CardBox, vueSeamlessScroll },
  setup() {
    const store = useStore()
    const taskFlowList = ref([])

    const fetchList = async () => {
      try {
        const res = await store.dispatch('fetchQueryDynamicOrderRecordList', {})
        if (res && res.data) {
          taskFlowList.value = res.data
        }
      } catch (e) {
        console.error('获取任务流转数据失败', e)
      }
    }

    // 供父组件调用的定时刷新方法
    const refreshData = () => {
      fetchList()
    }

    onMounted(() => {
      fetchList()
    })

    return {
      taskFlowList,
      refreshData
    }
  }
}
</script>

<style lang="scss" scoped>
.task-flow-container {
  width: 100%;
  height: calc(100% - 578px);
  min-height: 120px;
}

.task-flow-list-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 4px 0;
  box-sizing: border-box;
}

.task-flow-list {
  padding: 0 4px;
  box-sizing: border-box;
}

.task-flow-item {
  position: relative;
  width: 100%;
  height: 64px;
  margin-bottom: 10px;
  padding: 0 16px;
  box-sizing: border-box;

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
  }

  &__content {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__icon {
    width: 48px;
    height: 48px;
    object-fit: contain;
    flex-shrink: 0;
  }

  &__info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
  }

  &__text {
    font-size: 14px;
    color: #33cdff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: 'SourceHanSansCN-Medium';
  }

  &__time {
    font-size: 14px;
    color: #fff;
    font-family: 'SourceHanSansCN-Regular';
  }
}
</style>
